const { COLORS } = require("../colors");
const BASE = {
  brand: COLORS.orange.brand,
  background: COLORS.sephia,
  backgroundDarker: COLORS.black["DEFAULT"],
};
module.exports = {
  BASE,
};
